var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 2.5H6.25C5.91858 2.50033 5.60083 2.63213 5.36648 2.86648C5.13213 3.10083 5.00033 3.41858 5 3.75V17.5C5.00033 17.8314 5.13213 18.1492 5.36648 18.3835C5.60083 18.6179 5.91858 18.7497 6.25 18.75H13.75C14.0814 18.7495 14.399 18.6176 14.6333 18.3833C14.8676 18.149 14.9995 17.8314 15 17.5V3.75C14.9997 3.41858 14.8679 3.10083 14.6335 2.86648C14.3992 2.63213 14.0814 2.50033 13.75 2.5ZM13.75 3.75V5H6.25V3.75H13.75ZM6.25 17.5V6.25H13.75V17.5H6.25Z",
    fill: "#8898A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWhiteIcon);
export default __webpack_public_path__ + "static/media/mobile-white-icon.2ecd5c877884d464c5714577f7e60277.svg";
export { ForwardRef as ReactComponent };